export const LOGO_FULL_URL = "https://static.newo.ai/logo/logo-full.svg";
export const LOGO_URL = "https://static.newo.ai/logo/logo.svg";

export const SOCIALS = {
    discord: "https://discord.com/invite/2KNRfYaXFy",
    youtube: "https://www.youtube.com/@newoai/videos",
    docs: "https://help.newo.ai/",
};

export const SUPPORT_EMAIL = "support@newo.ai";

export const COMMUNITY_URL =
    "https://academy.newo.ai/products/communities/customer-community";

export const BILLING_SUBSCRIPTIONS = {
    monthly: [
        {
            id: "monthly_small",
            title: "Small",
            trialPrice: "$0",
            price: "$119",
            phoneSessions: "60",
            textSessions: "120",
        },
        {
            id: "monthly_medium",
            title: "Medium",
            trialPrice: "$0",
            price: "$339",
            phoneSessions: "200",
            textSessions: "400",
        },
        {
            id: "monthly_large",
            title: "Large",
            trialPrice: "$0",
            price: "$559",
            phoneSessions: "400",
            textSessions: "800",
        },
        {
            id: "monthly_corp",
            title: "Corp",
            trialPrice: "$0",
            price: "$889",
            phoneSessions: "800",
            textSessions: "1600",
        },
        {
            id: "monthly_enterprise",
            title: "Enterprise",
            trialPrice: "$0",
            price: "Custom",
            phoneSessions: "TBD",
            textSessions: "TBD",
        },
    ],
    annual: [
        {
            id: "annual_small",
            title: "Small",
            trialPrice: "$0",
            price: "$99",
            phoneSessions: "60",
            textSessions: "120",
        },
        {
            id: "annual_medium",
            title: "Medium",
            trialPrice: "$0",
            price: "$299",
            phoneSessions: "200",
            textSessions: "400",
        },
        {
            id: "annual_large",
            title: "Large",
            trialPrice: "$0",
            price: "$499",
            phoneSessions: "400",
            textSessions: "800",
        },
        {
            id: "annual_corp",
            title: "Corp",
            trialPrice: "$0",
            price: "$799",
            phoneSessions: "800",
            textSessions: "1600",
        },
        {
            id: "annual_enterprise",
            title: "Enterprise",
            trialPrice: "$0",
            price: "Custom",
            phoneSessions: "TBD",
            textSessions: "TBD",
        },
    ],
};
